import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DossierElement from "./components/dossier-element";
import Slider from "react-slick";
import { useSelector } from "react-redux";
import useScreenSize from "@pro/lib/use-screen-size";
import UniversalSliderButton from "@default/general-components/universal-slider-button";

/**
 * Maximum of three news or person entries.
 *
 * @todo Events.
 */
const ParagraphDossier = ({ content }) => {
  const sectionClassNames = classNames({
      "paragraph paragraph-dossier": true,
    }),
    [slideIndex, setSlideIndex] = useState(0),
    simpleDesign = useSelector(
      (reduxStore) => reduxStore.appStore.simpleDesign
    );

  const sliderRef = useRef();
  const isMobile = useScreenSize("lg");

  const slidesToShow = 3;

  const sliderSettings = {
    adaptiveHeight: false,
    arrows: false,
    fade: false,
    dots: false,
    slidesToShow,
    slidesToScroll: 1,
    touchMove: true,
    centerMode: false,
    infinite: false,
    beforeChange: (oldIndex, newIndex) => {
      setSlideIndex(newIndex);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow,
          touchMove: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.1,
          touchMove: true,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          touchMove: true,
        },
      },
    ],
  };

  let paragraphs =
    content.fieldParagraphs?.filter((paragraph) => paragraph?.status) || [];

  if (paragraphs.length < slidesToShow) {
    paragraphs = [...paragraphs, ...paragraphs];
  }

  const isPrevDisabled = slideIndex === 0;
  const isNextDisabled =
    slideIndex >= paragraphs.length - (isMobile ? 1 : slidesToShow);

  return (
    <section
      className={sectionClassNames}
      data-darkmode={content.fieldDarkMode}
    >
      {content.fieldHeading && (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="module-headline">{content.fieldHeading}</h2>
            </div>
          </div>
        </div>
      )}

      <div
        className={simpleDesign ? "container" : "slider-wrapper"}
        aria-roledescription="carousel"
      >
        <UniversalSliderButton
          type="prev"
          onClick={() => sliderRef.current?.slickPrev()}
          sliderClassNames={isPrevDisabled ? "slick-disabled" : ""}
          sliderRef={sliderRef}
          centerSelector={".main-image > *"}
        />
        <Slider ref={sliderRef} {...sliderSettings}>
          {paragraphs.map((item, index) => (
            <React.Fragment key={"dossier-element-" + item.id}>
              <DossierElement
                content={item}
                active={slideIndex === index}
                highlighted={content.fieldHighlighted}
              />
            </React.Fragment>
          ))}
        </Slider>
        <UniversalSliderButton
          type="next"
          onClick={() => sliderRef.current?.slickNext()}
          sliderClassNames={isNextDisabled ? "slick-disabled" : ""}
          sliderRef={sliderRef}
          centerSelector={".dossier-element .main-image"}
        />
      </div>
    </section>
  );
};

ParagraphDossier.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldHeading: PropTypes.string,
    fieldHighlighted: PropTypes.bool,
    fieldImage: PropTypes.shape({
      fieldMediaImage: PropTypes.shape({
        alt: PropTypes.string,
        title: PropTypes.string,
        style: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    fieldParagraphs: PropTypes.array,
  }),
};

export default ParagraphDossier;
